import { render, staticRenderFns } from "./ProfilePictureUpload.vue?vue&type=template&id=460d0236&scoped=true"
import script from "./ProfilePictureUpload.vue?vue&type=script&lang=js"
export * from "./ProfilePictureUpload.vue?vue&type=script&lang=js"
import style0 from "./ProfilePictureUpload.vue?vue&type=style&index=0&id=460d0236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460d0236",
  null
  
)

export default component.exports